module Meevo.Plugins.Employee {
    "use strict";
    /**
    * ImageGallery Section of Employee 
    */
    export class ImageGallerySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeImageGallery> {

        private imageGalleryService: Meevo.Components.Common.IImageGalleryService;

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Components.Modal.IModalService,
            imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            sectionSecurityKey?: string
             ) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun,null,sectionSecurityKey);

            this.imageGalleryService = imageGalleryService;
        }
  
        addImage() {
            return this.dataService.getTemplate('Employee', this.parentItemId, "ImageGallery")
                .then(result => {
                    result.fileType = Model.FileTypes.CustomDataImage;
                    result.file = result.meevoFile;
                    result.fileGuid = result.fileGuid;
                    result.mimeType = result.contentType;
                    result.isStorageUpdated = result.isStorageUpdated;
                    return result;
                })
        }

        getDefaultCriteria() {
            return { imageGalleryCategoryEnum: Model.ImageGalleryCategoryEnum.Employee, IncludeInactive: true, IncludeActive: true}
        }    


    }
}